import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const UTILITY_TRANSACTION_HISTORY = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'UTILITY_TRANSACTION_HISTORY')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/lifecenter/queryOrderList',
        method: 'POST',
        body: {
          ...data,
          orderTypes: ['WATER_ELECTRIC', 'PARKING_DEPOSIT', 'PARKING_BILL'],
          notOrderStatus: ['WAIT_PAY', 'TRADE_FAILED']
        },
        requestAction: UTILITY_TRANSACTION_HISTORY.INIT_REQUEST,
        successAction: UTILITY_TRANSACTION_HISTORY.INIT_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UTILITY_TRANSACTION_HISTORY.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [UTILITY_TRANSACTION_HISTORY.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'utilityTransactionHistory',
    reducerMap: {
      utilityTransactionHistoryState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
